import { select } from '@angular-redux/store';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TermsDialogData {
    termsUrl: string;
}

@Component({
    selector: 'ridango-terms-dialog',
    templateUrl: 'terms-dialog.component.html'
})
export class TermsDialogComponent {
    @select(['application', 'assetsPath']) assetsPath$;

    constructor(
        public dialogRef: MatDialogRef<TermsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TermsDialogData,
        @Inject('ENV') public env: any
    ) {}

    agreeTerms(agree: boolean) {
        this.dialogRef.close(agree);
    }
}
